export const enum ProviderFilterPlace {
	BAR = 'bar',
	SETTINGS = 'settings',
	// EXP_PROVIDER_BUYBOX_V2
	BUYBOX = 'buybox',
	// EXP_PROVIDER_BUYBOX_V2
}
